<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">业界最大！腾讯优图发布Real-IAD大规模工业异常检测数据集！</div>
      <div class="news-date">2024年10月29日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news53.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">Title:</span>
          Real-IAD: A Real-World Multi-View Dataset for Benchmarking Versatile Industrial Anomaly Detection 
        </p>
        <div class="news-p-title">
          <p>
            <strong>● 动机：为什么构建Large-scale Real-world Real-IAD数据集</strong>
          </p>
        </div>
        <p>
          · 一方面，大多数最先进的方法在MVTec / VisA等主流数据集上已经达到饱和(AUROC超过99%)，无法很好地区分方法之间的差异，且由于难度较小而与实际应用场景之间存在较大差距，
          <span class="mark-text highlight">因此需要更具挑战性的数据集来支持AD领域的进一步研究</span>。
        </p>
        <p>
          · 另一方面，各种新的实用异常检测设置的研究受到数据集规模的限制（比如带噪和小样本更贴近实际应用的setting），存在评估结果过拟合的风险，因此
          <span class="mark-text highlight">需要更大规模的数据集</span>来支持；
        </p>
        <p>
          · 工业生产中的良率通常介于60%-100%之间，与现有的100%良率实验setting不符，因此，
          <span class="mark-text highlight">需要更具实际应用价值的setting，即我们提出的Fully Unsupervised Industrial Anomaly Detection，FUIAD</span>。
        </p>  
        <div class="news-p-title">
          <p>
            <strong>● Real-IAD数据集特性：</strong>
          </p>
        </div>
        <p>· 更多的类别：30类真实产线物料</p>
        <p>· 大规模数据量：150K数据</p>
        <p>· 多种材料：金属，塑料，木材，陶瓷和混合材料</p>
        <p>· 多种缺陷类别：缺失、划伤、裂纹、脏污、破洞、变形、凹坑、破损</p>
        <p>· 多视角：5个拍摄角度（顶拍+4个侧拍）</p>
        <p>· 更高的分辨率：2K~5K</p>
        <p>· 支持多种实验设置：1）FUIAD；2）多视角AD；3）无监督AD；4）Zero-/Few-shot AD；5）带噪AD等</p>
        <p>
          与主流的2D异常检测数据集规模及属性对比如下表 
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news53/news53_1.png"/>
          </div>
        </div>
        <p>
          5个视角的采集效果图示例，包含两种典型异常场景：
        </p>
        <p>
          1）缺陷可以在一个sample中的每个view都可见
        </p>
        <p>
          2）缺陷仅在一个sample中部分view上可见
        </p>
        <p>
          这更具有实际意义和更大的挑战性，将AD推向实际应用迈出了新的一步！
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news53/news53_2.png"/>
          </div>
        </div>
        <div class="news-p-title">
          <p>
            <strong>● 本文贡献</strong>
          </p>
        </div>
        <p>· 提出了一个新的Real-IAD数据集，它比现有的主流数据集大十倍以上。它包括30类对象，每类对象包含5个拍摄角度，共计150K高分辨率图像。Real-IAD具有更大的缺陷面积和缺陷比例范围，能够更好地区分不同方法的性能，满足IAD的各种研究设置。</p>
        <p>· 基于Real-IAD数据集构建了一个更接近实际应用场景的FUIAD（Fully Unsupervised Industry Anomaly Detection）设置，其中仅使用大多数生产线的成品率大于60%的自然存在约束，而不引入额外的手动注释。</p>
        <p>· 我们报告了常用的IAD方法在Real-IAD数据集上在几种设置下的性能，并提供了一个极具挑战性的基准，以促进异常检测领域的发展。</p>
        <div class="news-p-title">
          <p>
            <strong>● 拆解 Real-IAD 数据收集的具体过程，如下图所示：</strong>
          </p>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news53/news53_3.png"/>
          </div>
        </div>
        <p>· 物料准备及缺陷产品构建</p>
        <p>· 材料：包含金属，塑料，木材，陶瓷和混合材料</p>
        <p>· 缺陷类型：包含缺失、划伤、裂纹、脏污、破洞、变形、凹坑、破损共8种</p>
        <p>· 原型采集设备准备：包含1个顶拍相机加4个侧拍相机</p>
        <p>· 工业级数据收集、标注、清洗过程：</p>
        <p>使用3个基于HRNet-32w主干网络的Cascade RCNN进行检测、交叉验证，直到检测结果偏差小于预定条件（AP基本不变，修改标注的图片数/instance足够小）</p>
        <div class="news-p-title">
          <p>
            <strong>● Real-IAD数据统计分析：</strong>
          </p>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news53/news53_4.png"/>
          </div>
        </div>
        <div class="download-article-wrap">
          <p>
            <span class="mark-text highlight">更多的数据信息、下载方式及Benchmark 结果可移步项目主页：</span><br/>
            <span>Project Page: https://realiad4ad.github.io/Real-IAD/</span>
          </p>
          <p>
            <span class="mark-text highlight">基于该数据集的已有开源方法推荐：</span><br/>
            <span>AD Benchmark: https://github.com/zhangzjn/ader</span><br/>
            <span>MambaAD[NeurIPS'24]: https://github.com/lewandofskee/MambaAD</span><br/>
            <span>Dinomaly: https://github.com/guojiajeremy/Dinomaly</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News53',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News53.vue